import {Alert, Breadcrumb, Button, Spin, Tabs} from "antd";

import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {ShareServiceWidget} from "../../../../components/calls/service/share-service-widget/share-service-widget";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {CanvaTemplateWidget} from "../../../../components/widgets/canva-template-widget";
import {ErrorBoundary} from "react-error-boundary";
import {useEffect, useState} from "react";
import {SalesAndInsights} from "../../../../components/calls/service/sales-and-insights";
import {useGetSessionContext} from "../../../../calls/useCases/editService/context/get-session";
import {EditSessionBasicForm} from "../../../../calls/useCases/editService/basic-form";
import {EditSessionCheckoutForm} from "../../../../calls/useCases/editService/checkout-form";
import {OfferingAutomations} from "../../../../components/offering-form/automations-step";

type TabKeys = "form" | "checkoutForm" | "automations" | "insights";

const EditCallPage = () => {
  const pageTitle = "Edit a session";
  const {
    state: {sessionData, session, isFetchingSession, isLoadingSession},
  } = useGetSessionContext();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<TabKeys>("form");
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "checkoutForm") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "insights") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "automations") {
        setDefaultActiveKey(activeTab);
      }
    }
  }, [activeTab]);

  function handleTabClick(key: string) {
    if (key === "form") {
      setDefaultActiveKey("form");
      navigate(`${window.location.pathname}?activeTab=form`);
    }
    if (key === "checkoutForm") {
      setDefaultActiveKey("checkoutForm");
      navigate(`${window.location.pathname}?activeTab=checkoutForm`);
    }
    if (key === "automations") {
      setDefaultActiveKey("automations");
      navigate(`${window.location.pathname}?activeTab=automations`);
    }
    if (key === "insights") {
      setDefaultActiveKey("insights");
      navigate(`${window.location.pathname}?activeTab=insights`);
    }
  }
  return (
    <DashboardWrapper pageTitle={pageTitle}>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/calls">1:1 Sessions</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span
            style={{
              opacity: isFetchingSession ? 0.2 : 1,
            }}
          >
            {isLoadingSession ? <Spin /> : sessionData.name}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <StyledPageWrapper>
        <div className="main-area">
          <Tabs
            defaultActiveKey={defaultActiveKey}
            activeKey={defaultActiveKey}
            onTabClick={(key) => handleTabClick(key)}
          >
            <Tabs.TabPane tab="Session details" key="form">
              <Spin spinning={isFetchingSession}>
                <ErrorBoundary
                  FallbackComponent={({error, resetErrorBoundary}) => (
                    <div>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  )}
                >
                  <EditSessionBasicForm />
                </ErrorBoundary>
              </Spin>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Checkout form" key="checkoutForm">
              <Spin spinning={isFetchingSession}>
                <ErrorBoundary
                  FallbackComponent={({error, resetErrorBoundary}) => (
                    <div>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  )}
                >
                  <EditSessionCheckoutForm />
                </ErrorBoundary>
              </Spin>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Automations" key="automations">
              <Spin spinning={isFetchingSession}>
                <ErrorBoundary
                  FallbackComponent={({error, resetErrorBoundary}) => (
                    <div>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  )}
                >
                  <OfferingAutomations contextOfferingId={sessionData.id} />
                </ErrorBoundary>
              </Spin>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Sales and insights" key="insights">
              {session && <SalesAndInsights session={session} />}
            </Tabs.TabPane>
          </Tabs>
        </div>
        <div className="widget-area">
          <ShareServiceWidget
            serviceId={sessionData.id}
            serviceData={sessionData}
            isFetchingSession={isFetchingSession}
          />
          <CanvaTemplateWidget url="https://www.canva.com/design/DAGOSXnkoPE/5Fg__pLqNu6jl-cliuexgQ/view?utm_content=DAGOSXnkoPE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview" />
        </div>
      </StyledPageWrapper>
    </DashboardWrapper>
  );
};

export {EditCallPage};
